import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import AddressList from "Constants/AddressList";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import AppConfig from "Constants/AppConfig";
import {
  changeProjectSearch,
  getAllProjectCustomerList,
  getCustomerList,
  getGrouhMoshtari,
  insertProject,
  selectCustomerForAdmin,
} from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiButton from "Components/MuiButton/MuiButton";
import { Alert } from "@material-ui/lab";
import {
  ALL_PROJECT_LIST,
  SELECTED_CUSTOMER,
  SELECTED_CUSTOMER_ADMIN,
} from "Stores/actionTypes";
import ProjectService from "Services/http/endpoints/project/ProjectService";
import StatusHandler from "Helpers/StatusHandler";
import { DialogActions } from "@material-ui/core";
import infoIcon from "Assets/svg/icon/info.svg";
import { ReactSVG } from "react-svg";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from "react-bootstrap-icons";

function NewProjectForm() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    selectedUser,
    projectsListPagination,
    projectDataSearch,
    allCustomerForAdmin,
    allCustomers,
    selectedCustomerAdmin,
    selectedCustomer,
    customerGroup,
    userData,
  } = useSelector((state) => ({
    selectedUser: state.project.selectedUser,
    selectedCustomerAdmin: state.project.selectedCustomerAdmin,
    selectedCustomer: state.project.selectedCustomer,
    projectsListPagination: state.project.projectsListPagination,
    projectDataSearch: state.project.projectDataSearch,
    allCustomerForAdmin: state.project.allCustomerForAdmin,
    allCustomers: state.project.allCustomers,
    customerGroup: state.customer.customerGroup,
    userData: state.auth.userData,
  }));
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [newCustomerValid, setNewCustomerValid] = useState({});
  const [newCustomer, setNewCustomer] = useState(false);
  const [noCustomer, setNoCustomer] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [formDisable, setFormDisable] = useState(true);
  const [controls, setControls] = useSetState({
    projectName: {
      type: "text",
      label: "project_name_input",
      value: "",
      validation: {
        required: true,
      },
      row: 1,
      col: {
        sm: 12,
        xs: 12,
      },
    },
    customers: {
      type: "select",
      label: "customers_name_input",
      selectItems: [],
      hasFunction: {
        onClick: () => toggleNewCustomer(),
        unClickedLabel: {
          label: "newCustomer",
          icon: <Icons.Plus />,
        },
        clickedLabel: {
          label: "enseraf",
          icon: <Icons.X />,
        },
      },
      value: "",
      validation: null,
      row: 1,
      col: {
        sm: 12,
        xs: 12,
      },
    },
    customerGroup: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      row: 2,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    customerName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      row: 2,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    mobile: {
      type: "mobile",
      value: "",
      validation: {
        required: true,
        isNumeric: true,
        isPhoneSignUp: true,
      },
      row: 2,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    ostan: {
      type: "select",
      selectItems: AddressList.Ostan,
      value: "",
      validation: null,
      row: 3,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    city: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      row: 3,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    address: {
      type: "text",
      value: "",
      validation: null,
      row: 3,
      col: {
        sm: 12,
        xs: 12,
      },
    },
    maliyat: {
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
      row: 3,
      col: {
        sm: 4,
        xs: 4,
      },
    },
    nasb: {
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
      row: 3,
      col: {
        sm: 4,
        xs: 4,
      },
    },
    mavadMasrafi: {
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
      row: 3,
      col: {
        sm: 4,
        xs: 4,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    if (name === "customerName" || name === "mobile") {
      setNewCustomerValid((prev) => ({ ...prev, [name]: validation }));
    } else {
      setFormValid((prev) => ({ ...prev, [name]: validation }));
    }
  };

  useEffect(() => {
    setControls({ customerGroup: { value: customerGroup[0] } });
    setControls({ customerGroup: { selectItems: customerGroup } });
  }, [customerGroup]);

  const toggleNewCustomer = () => {
    if (!noCustomer) setNewCustomer(!newCustomer);
    else setNewCustomer(true);
  };

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });

    // if(controlName === 'customers')
    //   dispatch(changeProjectSearch({ ...projectDataSearch, customers: value, changeOut: true }));

    if (controlName === "ostan") {
      const ctSelectItems = AddressList.city.filter(
        (s) => s.ostan === value.value,
      );
      setControls({ city: { selectItems: ctSelectItems } });
      setControls({ city: { value: ctSelectItems[0] } });
    }
  };

  const onClear = () => {
    setCheckValid(false);
    setNewCustomer(false);
    setNoCustomer(false);
    setControls({ projectName: { value: "" } });
    setControls({ ostan: { value: "" } });
    setControls({ city: { value: "" } });
    setControls({ address: { value: "" } });
    setControls({ maliyat: { value: 0 } });
    setControls({ nasb: { value: 0 } });
    setControls({ customerGroup: { value: "" } });
    setControls({ customerName: { value: "" } });
    setControls({ mobile: { value: "" } });
    setControls({ mavadMasrafi: { value: 0 } });
    setFormValid({ projectName: false });
    // setNewCustomerValid({ customerName: false, mobile: false });
    if (["1", "5"].includes(read("StypeU")) && read("UserC") === "-") {
      const newArr = allCustomerForAdmin.filter((item) => {
        return item.Id !== -1;
      });
      if (newArr.length === 0) {
        setNoCustomer(true);
        setNewCustomer(true);
      } else {
        setControls({
          customers: {
            value:
              selectedCustomerAdmin.Id === -1
                ? newArr[0]
                : selectedCustomerAdmin,
          },
        });
        setControls({ customers: { selectItems: newArr } });
      }
    } else {
      const newArr = allCustomers.filter((item) => {
        return item.Id !== -1;
      });
      if (newArr.length === 0) {
        setNoCustomer(true);
        setNewCustomer(true);
      } else {
        setControls({
          customers: {
            value: selectedCustomer.Id === -1 ? newArr[0] : selectedCustomer,
          },
        });
        setControls({ customers: { selectItems: newArr } });
      }
    }
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);

    let main_result =
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true);

    let additional_result = true;
    if (newCustomer)
      additional_result =
        !R.isEmpty(newCustomerValid) &&
        Object.values(newCustomerValid).every((item) => item === true);

    if (main_result && additional_result) {
      const {
        projectName,
        city,
        address,
        maliyat,
        nasb,
        mavadMasrafi,
        customers,
        customerGroup,
        customerName,
        mobile,
      } = controls;
      try {
        let _mobile = mobile.value;
        if (mobile.value.charAt(0) === "0")
          _mobile = mobile.value.replace("0", "");
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: selectedUser ? selectedUser.Key : read("userKey"),
          Name: projectName.value,
          IdCustomer: newCustomer ? -1 : customers.value.value,
          IdGroupCustomer: newCustomer
            ? customerGroup.value.Id
            : customers.value.IdGroupCustomer,
          NameCustomer: newCustomer
            ? customerName.value
            : customers.value.label,
          Mobile: newCustomer ? _mobile : "",
          IdCity: city.value.value,
          Tax: +maliyat.value,
          CostInstall: +nasb.value,
          CostMaterial: +mavadMasrafi.value,
          Address: address.value,
        };
        const insert_status = await dispatch(insertProject(data));
        if (insert_status) {
          if (!newCustomer) {
            dispatch(
              changeProjectSearch({
                ...projectDataSearch,
                customers: customers.value,
                changeOut: true,
              }),
            );
          } else {
            if (["1", "5"].includes(read("StypeU")) && read("UserC") === "-") {
              const paramsCustomer = {
                KeyGroup: read("groupKey"),
                KeyUser: read("userKey"),
                KeyRequestUser: selectedUser.Key,
                All: true,
              };
              const responseCustomer = await dispatch(
                selectCustomerForAdmin(paramsCustomer),
              );
              if (responseCustomer.length > 0) {
                dispatch({
                  type: SELECTED_CUSTOMER_ADMIN,
                  selectedCustomerAdmin: responseCustomer[0],
                });
                const paramsList = {
                  KeyGroup: read("groupKey"),
                  KeyUser: read("userKey"),
                  IdCustomer: responseCustomer[0].value,
                  KeyRequestUser: selectedUser.Key,
                  Name: projectDataSearch?.Name,
                  IdProject: 0,
                  Limit: projectsListPagination.Limit,
                  Page: 1,
                };
                await dispatch(getAllProjectCustomerList(paramsList));
              } else {
                dispatch({
                  type: ALL_PROJECT_LIST,
                  projectsList: [],
                  projectsListPagination: { Limit: 3, Page: 1, Total: 0 },
                });
              }
            } else if (read("StypeU") === "2" || read("UserC") === "zero") {
              const params = {
                keyGroup: read("groupKey"),
                keyUser: read("userKey"),
              };
              const response = await dispatch(getCustomerList(params));
              dispatch({
                type: SELECTED_CUSTOMER,
                selectedCustomer: response[0],
              });
              const paramsList = {
                KeyGroup: read("groupKey"),
                KeyUser: read("userKey"),
                IdCustomer: response[0].value,
                IdProject: 0,
                Name: projectDataSearch?.Name,
                Limit: projectsListPagination.Limit,
                Page: projectsListPagination.Page,
              };
              await dispatch(getAllProjectCustomerList(paramsList));
            }
            dispatch(
              changeProjectSearch({
                ...projectDataSearch,
                customers: -1,
                changeOut: true,
              }),
            );
          }
          handleDialog();
        }
      } catch (e) {
        showNotify({
          text: t("invalidInformation"),
          customClass: "error",
        });
      }
    } else {
      setCheckValid(!main_result);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (["1", "5"].includes(read("StypeU")) && read("UserC") === "-") {
      if (selectedUser) {
        if (selectedUser.NameStype === "All") {
          setFormDisable(true);
        } else {
          setFormDisable(false);
        }
      } else {
        setFormDisable(true);
      }
    } else {
      setFormDisable(false);
    }
  }, [selectedUser]);

  const onEnter = async () => {
    if (
      userData?.panel &&
      userData?.panel?.isFree &&
      projectsListPagination.Total >= userData?.panel?.maxProject
    ) {
      showNotify({
        text: t("freeAccountLimit"),
        customClass: "error",
      });
      handleDialog();
      return;
    }
    setLoading(true);
    await onClear();
    try {
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
      };
      const response = await ProjectService.getLastProjectInfo(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const ct = AddressList.city.find(
          (c) => c.value === response.data.Value.IdCity,
        );
        const pr = AddressList.Ostan.find((o) => o.value === ct.ostan);
        const ctSelectItems = AddressList.city.filter(
          (s) => s.ostan === AppConfig.defaultProvince,
        );
        setControls({ ostan: { value: pr } });
        setControls({ city: { value: ct } });
        setControls({ city: { selectItems: ctSelectItems } });
        if (controls.customers.value.value === 0) {
          const customer = controls.customers.selectItems.find(
            (c) => c.Id === response.data.Value.IdCustomer,
          );
          if (customer) setControls({ customers: { value: customer } });
          else if (controls.customers.selectItems.len > 0) {
            const customerDefault = controls.customers.selectItems[0];
            setControls({ customers: { value: customerDefault } });
          }
        }
      }

      const _params = {
        KeyGroup: read("groupKey"),
        KeyUser: selectedUser ? selectedUser.Key : read("userKey"),
      };
      await dispatch(getGrouhMoshtari(_params));
    } catch (err) {
      console.error("[catch error]", err);
    }
    setLoading(false);
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <MuiButton
        color="primary"
        title={<Translator id="createNewProject" />}
        innerIcon={<Icons.PlusLg />}
        onClick={handleDialog}
        disabled={formDisable}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <div className="dialogHeader">
          <p>{<Translator id="createNewProject" />}</p>
        </div>
        <DialogContent>
          <Grid container spacing={1}>
            {selectedUser && (
              <Grid item xs={12} className="mb-3">
                <Alert
                  severity="info"
                  variant="outlined"
                  icon={<ReactSVG src={infoIcon} />}
                >
                  <>
                    {t("input_userName")} : {selectedUser.DisplayName}
                  </>
                </Alert>
              </Grid>
            )}
            {Object.keys(controls)
              .filter((key) => controls[key].row === 1)
              .map((key, index) => {
                return (
                  <Grid
                    item
                    sm={controls[key].col.sm}
                    xs={controls[key].col.xs}
                    key={key + index}
                  >
                    {controls[key].type === "text" && (
                      <Input
                        name={key}
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        placeholder={t(key)}
                        validation={controls[key].validation}
                        checkValid={checkValid}
                        label={
                          controls[key].label ? (
                            <Translator id={controls[key].label} />
                          ) : (
                            <Translator id={key} />
                          )
                        }
                        type="text"
                      />
                    )}
                    {controls[key].type === "select" && (
                      <MuiAutoComplete
                        autoSelect={true}
                        options={controls[key].selectItems}
                        label={
                          controls[key].label ? (
                            <Translator id={controls[key].label} />
                          ) : (
                            <Translator id={key} />
                          )
                        }
                        value={controls[key].value}
                        id={key}
                        onChange={autoCompleteHandler}
                        disabled={newCustomer}
                        buttonLabel={
                          controls[key].hasFunction ? (
                            <span
                              className={`inner-label-button ${
                                newCustomer ? "cancel" : "active"
                              }`}
                              onClick={toggleNewCustomer}
                            >
                              {newCustomer ? (
                                <>
                                  {controls[key].hasFunction.clickedLabel.icon}
                                  {t(
                                    controls[key].hasFunction.clickedLabel
                                      .label,
                                  )}
                                </>
                              ) : (
                                <>
                                  {
                                    controls[key].hasFunction.unClickedLabel
                                      .icon
                                  }
                                  {t(
                                    controls[key].hasFunction.unClickedLabel
                                      .label,
                                  )}
                                </>
                              )}
                            </span>
                          ) : (
                            false
                          )
                        }
                      />
                    )}
                  </Grid>
                );
              })}
            <Grid
              container
              spacing={1}
              className={`insertNewCustomer ${newCustomer ? "active" : "hide"}`}
            >
              {Object.keys(controls)
                .filter((key) => controls[key].row === 2)
                .map((key, index) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key + index}
                    >
                      {controls[key].type === "text" && (
                        <Input
                          name={key}
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          placeholder={t(key)}
                          validation={controls[key].validation}
                          checkValid={checkValid}
                          label={<Translator id={key} />}
                          type="text"
                          disabled={!newCustomer}
                        />
                      )}
                      {controls[key].type === "mobile" && (
                        <Input
                          name={key}
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          placeholder={t(key)}
                          validation={controls[key].validation}
                          checkValid={checkValid}
                          label={<Translator id={key} />}
                          type="text"
                          className={"phone"}
                          maxlength="11"
                          helperText={"mobileExample"}
                          disabled={!newCustomer}
                        />
                      )}
                      {controls[key].type === "select" && (
                        <MuiAutoComplete
                          autoSelect={true}
                          options={controls[key].selectItems}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          id={key}
                          onChange={autoCompleteHandler}
                          disabled={!newCustomer}
                        />
                      )}
                    </Grid>
                  );
                })}
            </Grid>
            <Grid item xs={12} className="my-2">
              <Translator id={"newProjectAddressInfo"} />
            </Grid>
            {Object.keys(controls)
              .filter((key) => controls[key].row === 3)
              .map((key, index) => {
                return (
                  <Grid
                    item
                    sm={controls[key].col.sm}
                    xs={controls[key].col.xs}
                    key={key + index}
                    className={controls[key].type === "percent" ? "my-2" : ""}
                  >
                    {controls[key].type === "text" && (
                      <Input
                        name={key}
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        placeholder={t(key)}
                        validation={controls[key].validation}
                        checkValid={checkValid}
                        label={<Translator id={key} />}
                        type="text"
                      />
                    )}
                    {controls[key].type === "percent" && (
                      <Input
                        name={key}
                        setValue={setValue.bind(this)}
                        defaultValue={controls[key].value}
                        validation={controls[key].validation}
                        endIcon="%"
                        label={<Translator id={key} />}
                        type={controls[key].type}
                      />
                    )}
                    {controls[key].type === "select" && (
                      <MuiAutoComplete
                        autoSelect={true}
                        options={controls[key].selectItems}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        id={key}
                        onChange={autoCompleteHandler}
                      />
                    )}
                  </Grid>
                );
              })}
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton
            color="primary"
            className="main-large-button"
            onClick={onFinish}
            title={<Translator id="button_save" />}
          />
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default NewProjectForm;
